__webpack_require__.p = "https://component-test.hxxlpg.com/";